import { ReactNode } from 'react';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';

interface NormalPageTitleProps {
  title: string;
  /** 제목 오른쪽에 붙는 버튼 등 */
  action?: ReactNode;
}

/**
 * 페이지 상단 제목 (h1). 페이지당 하나만 사용
 *
 * NormalPage 안에서 사용 (예: 클래스 관리, 내 학습)
 * - xl 미만 좌우 여백은 NormalPage가 처리하므로 여기선 여백 없음
 * - xl 이상은 최대 1176px 가운데 정렬(좌우 최소 20px), 높이 90px
 * - PageContainer 안에서는 PageContainerTitle 사용 (여기서 쓰면 xl 미만 좌우 여백이 없음)
 */
export const NormalPageTitle = ({ title, action }: NormalPageTitleProps) => {
  useDocumentTitle(title);

  return (
    <header className="mx-auto flex items-center justify-between xl:h-[90px] xl:max-w-page">
      <h1 className="text-title_h2 text-black xl:text-title_h1">{title}</h1>
      {action}
    </header>
  );
};
